export default __webpack_public_path__ + "img/1_9-9fabc71a.png";